/**
 * Meta Pixel (id 1749956882712100) — installed once, globally.
 *
 * This project has no editable index.html, so the official base code is
 * injected verbatim into <head> at runtime. The guards below ensure the
 * script and the PageView event are never duplicated, even across
 * re-renders, route changes or hot reloads.
 *
 * The <noscript> fallback image is intentionally NOT injected: this code only
 * ever runs with JavaScript enabled, and a runtime-created <img> inside a
 * <noscript> element is still fetched by the browser, which would fire a
 * second, duplicated PageView (ev=PageView&noscript=1).
 */

const PIXEL_ID = '1749956882712100'
const MARKER = 'data-meta-pixel'

const BASE_CODE = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`

export function installMetaPixel(): void {
  if (typeof document === 'undefined') return

  // Clean up any previously injected noscript fallback so its tracking pixel
  // can never fire a duplicate PageView in a JS-enabled browser.
  document
    .querySelectorAll(`noscript[${MARKER}]`)
    .forEach((node) => node.remove())

  if (document.querySelector(`script[${MARKER}]`)) return

  const script = document.createElement('script')
  script.setAttribute(MARKER, 'base-code')
  script.text = BASE_CODE
  document.head.appendChild(script)
}
